import { useEffect, useMemo } from "react";
import {
  applyEnvDocumentMeta,
  clearEnvDocumentMeta,
  getEnvBanner,
} from "../../../assets/helpers/appEnvironment";
import "./EnvBanner.scss";

export const EnvBanner = () => {
  const banner = useMemo(() => getEnvBanner(), []);

  useEffect(() => {
    applyEnvDocumentMeta(banner);

    return () => {
      clearEnvDocumentMeta();
    };
  }, [banner]);

  if (!banner) {
    return null;
  }

  return (
    <div
      className={`env-banner env-banner-${banner.tone}`}
      role="status"
      aria-live="polite"
    >
      <strong>{banner.title}</strong>
      <span>{banner.text}</span>
    </div>
  );
};
